import { useMemo } from 'react'
import { Bill, Subscription } from '../Bills'

export const useActiveSubscription = (bill: Bill, subscriptions: Subscription[]) => {
    const activeSubscriptions = useMemo(() => {
        return subscriptions.filter((subscription) => subscription.accountId === bill.id)
    }, [bill.id, subscriptions])

    const subscription = activeSubscriptions[0] ?? null

    return { subscription, activeSubscriptions, hasSubscription: activeSubscriptions.length > 0 }
}
